import React, { useState, useEffect } from 'react';
import AnalyticsNavbar from '../generic/navbar';
type Action = {
  label: string;
  onClick: () => void;
  active?: boolean;
  default?: boolean;
  translationFallback?: string;
  updateHash?: boolean;
};

interface AnalyticsLayoutProps {
  actions: Action[];
  tabs: Record<string, React.ReactNode>; // hash -> component
  commonHeader?: React.ReactNode;
}

const AnalyticsPagesLayout: React.FC<AnalyticsLayoutProps> = ({
  actions,
  tabs,
  commonHeader
}) => {
  const [activeTab, setActiveTab] = useState<string>(
    () =>
      window.location.hash?.replace('#', '') ||
      actions.find((a) => a.default)?.label ||
      actions[0].label
  );

  useEffect(() => {
    const handleHashChange = () => {
      setActiveTab(window.location.hash?.replace('#', '') || actions[0].label);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [actions]);

  return (
    <div>
      <div className="m-2" />
      <AnalyticsNavbar actions={actions} />
      {commonHeader}
      {commonHeader && <div className="m-2" />}
      {tabs[activeTab]}
    </div>
  );
};

export default AnalyticsPagesLayout;
